export const getSearchParams = search => new URLSearchParams(search);
